import Dialog from "@material-ui/core/Dialog";
import { DialogContent, DialogTitle } from "@material-ui/core/";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { BaseUrl, ImageBaseUrl as DOMAIN } from "../../../Environment";
import "./PersonInfoModal.scss";
import { withNamespaces } from "react-i18next";
import { Tooltip, IconButton } from "@mui/material";
import { toast } from "react-toastify";
import Axios from "axios";
import { getSecureItem } from "../../../utilsFunctions";
import {
  Download,
  Visibility,
  EditOutlined,
  DeleteOutlineOutlined,
} from "@mui/icons-material";

class PersonInfoModal extends Component {
  constructor() {
    super();
    this.state = {
      customerDetail: {},
      showDeleteConfirm: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ customerDetail: nextProps.customerInfo });
  }

  onEditIconClick = (customerID) => {
    this.props.history.push({
      pathname: "/customers/addcustomer",
      params: customerID,
    });
  };

  deleteCustomer = async (customerId) => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getSecureItem("token"),
    };
    const data = { id: customerId, collectorId: getSecureItem("userid") };

    Axios({
      url: `${BaseUrl}/customer/deleteCustomer`,
      method: "POST",
      data,
      headers,
    })
      .then((res) => {
        if (res.data.msg) {
          this.setState({ customerDetail: {}, showDeleteConfirm: false });
          toast.success("Deleted successfully.", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
          });
          this.props.close();
        }
      })
      .catch((err) => console.log(err));
  };

  getInitials = (first, last) => {
    return `${first?.[0] || ""}${last?.[0] || ""}`.toUpperCase();
  };

  render() {
    const { customerDetail, showDeleteConfirm } = this.state;
    const { t, mainPage } = this.props;
    const userPermissions = getSecureItem("UsersAccess");
    const isInternational = getSecureItem("country")?.code !== "91";

    const Field = ({ label, value, mono }) => (
      <div className="pim-field">
        <span className="pim-field__label">{label}</span>
        <span
          className={`pim-field__value${mono ? " pim-field__value--mono" : ""}`}
        >
          {value || "—"}
        </span>
      </div>
    );

    return (
      <Dialog open={this.props.open} className="pim-dialog">
        <div className="pim-modal">
          <div className="pim-header">
            <h2 className="pim-header__title">
              {t("AddCustomer.personalinfo")}
            </h2>
            <div className="pim-header__actions">
              {mainPage && (
                <>
                  {userPermissions?.editBorrowers && (
                    <Tooltip title="Edit customer">
                      <button
                        className="pim-icon-btn"
                        onClick={() =>
                          this.onEditIconClick(customerDetail.customerId)
                        }
                      >
                        <EditOutlined
                          style={{ fontSize: 16, color: "#3E4664" }}
                        />
                      </button>
                    </Tooltip>
                  )}
                  {userPermissions?.deleteBorrowers && (
                    <Tooltip title="Delete customer">
                      <button
                        className="pim-icon-btn pim-icon-btn--danger"
                        onClick={() =>
                          this.setState({
                            showDeleteConfirm: !showDeleteConfirm,
                          })
                        }
                      >
                        <DeleteOutlineOutlined
                          style={{ fontSize: 16, color: "#f5666a" }}
                        />
                      </button>
                    </Tooltip>
                  )}
                </>
              )}
              <button className="pim-icon-btn" onClick={this.props.close}>
                <CloseIcon style={{ fontSize: 16, color: "#8E8E98" }} />
              </button>
            </div>
          </div>

          <div className="pim-body">
            {showDeleteConfirm && (
              <div className="pim-delete-confirm">
                <p>
                  Deleting this customer will permanently remove all loan
                  transaction details. This cannot be undone.
                </p>
                <div className="pim-delete-confirm__actions">
                  <button
                    className="pim-btn pim-btn--ghost"
                    onClick={() => this.setState({ showDeleteConfirm: false })}
                  >
                    Cancel
                  </button>
                  <button
                    className="pim-btn pim-btn--danger"
                    onClick={() =>
                      this.deleteCustomer(customerDetail.customerId)
                    }
                  >
                    Delete customer
                  </button>
                </div>
              </div>
            )}

            <div className="pim-hero">
              <div className="pim-avatar">
                {customerDetail.profileImg ? (
                  <img
                    src={customerDetail.profileImg}
                    alt="profile"
                    className="pim-avatar__img"
                  />
                ) : (
                  <span>
                    {this.getInitials(
                      customerDetail.firstName,
                      customerDetail.lastName,
                    )}
                  </span>
                )}
              </div>
              <div className="pim-hero__info">
                <div className="pim-hero__name">
                  {customerDetail.firstName
                    ? `${customerDetail.firstName} ${customerDetail.lastName}`
                    : "—"}
                  <span className="pim-loans-badge">
                    {customerDetail.noOfLoans || 0} {t("NewCustomer.loans")}
                  </span>
                </div>
                <div className="pim-hero__meta">
                  {customerDetail.dob && (
                    <span className="pim-meta-chip">
                      {moment(customerDetail.dob).format("DD MMM YYYY")}
                    </span>
                  )}
                  {customerDetail.gender && (
                    <span className="pim-meta-chip">
                      {customerDetail.gender}
                    </span>
                  )}
                  {customerDetail.phone && (
                    <span className="pim-meta-chip">
                      {customerDetail.phone}
                    </span>
                  )}
                  {customerDetail.email && (
                    <span className="pim-meta-chip">
                      {customerDetail.email}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="pim-section">
              <div className="pim-section__title">{t("AddCustomer.fCard")}</div>
              <div className="pim-grid pim-grid--3">
                <Field
                  label={t("AddCustomer.annincome")}
                  value={customerDetail.annualIncome}
                />
                <Field
                  label={t("AddCustomer.status")}
                  value={customerDetail.maritalStatus}
                />
                <Field
                  label={t("AddCustomer.majscr")}
                  value={customerDetail.incomeSource}
                />
                <Field
                  label={t("AddCustomer.dadname")}
                  value={customerDetail.fatherName}
                />
                <Field
                  label={t("AddCustomer.momname")}
                  value={customerDetail.motherName}
                />
                <Field
                  label={
                    isInternational ? "National ID" : t("AddCustomer.addar")
                  }
                  value={customerDetail.aadhar}
                  mono
                />
                <Field
                  label={
                    isInternational ? "Passport No." : t("AddCustomer.pan")
                  }
                  value={customerDetail.pan}
                  mono
                />
              </div>
            </div>

            <div className="pim-section">
              <div className="pim-section__title">{t("AddCustomer.sCard")}</div>
              <div className="pim-grid pim-grid--2">
                <div className="pim-field">
                  <span className="pim-field__label">
                    {t("AddCustomer.address")}
                  </span>
                  {customerDetail.addresses ? (
                    <div className="pim-field__value pim-field__value--address">
                      {[
                        customerDetail.addresses[0]?.AddressLine,
                        customerDetail.addresses[0]?.AddressStreet,
                        customerDetail.addresses[0]?.AddressLandmark,
                        customerDetail.addresses[0]?.AddressCity,
                        `${customerDetail.addresses[0]?.AddressState || ""} ${customerDetail.addresses[0]?.AddressPincode || ""}`.trim(),
                      ]
                        .filter(Boolean)
                        .map((line, i) => (
                          <div key={i}>{line}</div>
                        ))}
                    </div>
                  ) : (
                    <span className="pim-field__value">—</span>
                  )}
                </div>
                <div className="pim-field">
                  <span className="pim-field__label">
                    {t("AddCustomer.offaddrss")}
                  </span>
                  {customerDetail.addresses ? (
                    <div className="pim-field__value pim-field__value--address">
                      {[
                        customerDetail.addresses[1]?.AddressLine,
                        customerDetail.addresses[1]?.AddressStreet,
                        customerDetail.addresses[1]?.AddressLandmark,
                        customerDetail.addresses[1]?.AddressCity,
                        `${customerDetail.addresses[1]?.AddressState || ""} ${customerDetail.addresses[1]?.AddressPincode || ""}`.trim(),
                      ]
                        .filter(Boolean)
                        .map((line, i) => (
                          <div key={i}>{line}</div>
                        ))}
                    </div>
                  ) : (
                    <span className="pim-field__value">—</span>
                  )}
                </div>
              </div>
            </div>

            <div className="pim-section">
              <div className="pim-section__title">
                {t("AddCustomer.ThCard")}
              </div>
              <div className="pim-grid pim-grid--2">
                <Field
                  label={t("AddCustomer.place")}
                  value={customerDetail.collectionDetail?.collectonPlace}
                />
                <Field
                  label={t("AddCustomer.time")}
                  value={customerDetail.collectionDetail?.collectionTime}
                />
              </div>
            </div>

            <div className="pim-section">
              <div className="pim-section__title">{t("AddCustomer.FCard")}</div>
              <div className="pim-grid pim-grid--3">
                <Field
                  label={t("AddCustomer.bname")}
                  value={customerDetail.bankDetail?.bankName}
                />
                <Field
                  label={t("AddCustomer.accnum")}
                  value={customerDetail.bankDetail?.accountNumber}
                  mono
                />
                <Field
                  label={t("AddCustomer.acctype")}
                  value={customerDetail.bankDetail?.accountType}
                />
                <Field
                  label={t("AddCustomer.ifsc")}
                  value={customerDetail.bankDetail?.ifsc}
                  mono
                />
              </div>
            </div>

            {!mainPage && (
              <div className="pim-section">
                <div className="pim-section__title">Co-Applicant Details</div>
                <div className="pim-grid pim-grid--2">
                  <Field
                    label="Name"
                    value={customerDetail.coApplicant?.coApplicantName}
                  />
                  <Field
                    label="Mobile Number"
                    value={customerDetail.coApplicant?.coApplicantMobNo}
                  />
                  <Field
                    label="Address"
                    value={customerDetail.coApplicant?.coApplicantAddress}
                  />
                  <Field
                    label="Relation"
                    value={customerDetail.coApplicant?.coApplicantRelation}
                  />
                  <Field
                    label="PAN Number"
                    value={customerDetail.coApplicant?.coApplicantPAN}
                    mono
                  />
                  <Field
                    label="Aadhaar Number"
                    value={customerDetail.coApplicant?.coApplicantAADHAR}
                    mono
                  />
                </div>
              </div>
            )}

            {!mainPage && (
              <div className="pim-section">
                <div className="pim-section__title">Guarantor Details</div>
                <div className="pim-grid pim-grid--2">
                  <Field
                    label="Name"
                    value={customerDetail.guarantor?.guarantorName}
                  />
                  <Field
                    label="Mobile Number"
                    value={customerDetail.guarantor?.guarantorMobNo}
                  />
                  <Field
                    label="Address"
                    value={customerDetail.guarantor?.guarantorAddress}
                  />
                </div>
              </div>
            )}

            {!mainPage && (
              <div className="pim-section">
                <div className="pim-section__title">Nominee Details</div>
                <div className="pim-grid pim-grid--2">
                  <Field
                    label="Name"
                    value={customerDetail.nominee?.nomineeName}
                  />
                  <Field
                    label="Mobile Number"
                    value={customerDetail.nominee?.nomineeMobNo}
                  />
                  <Field
                    label="Date of Birth"
                    value={customerDetail.nominee?.nomineeDOB}
                  />
                  <Field
                    label="Aadhaar Number"
                    value={customerDetail.nominee?.nomineeAADHAR}
                    mono
                  />
                </div>
              </div>
            )}

            <div className="pim-section">
              <div className="pim-section__title">
                {t("AddCustomer.fifthCrad")}
              </div>
              <div className="pim-grid pim-grid--2">
                <div className="pim-field">
                  <span className="pim-field__label">
                    {t("AddCustomer.refname")}
                  </span>
                  <span className="pim-field__value">
                    {customerDetail.referenceDetail?.referenceName1 || "—"}
                  </span>
                  <span className="pim-field__sub">
                    {customerDetail.referenceDetail?.referenceNumber1}
                  </span>
                </div>
                <div className="pim-field">
                  <span className="pim-field__label">
                    {t("AddCustomer.reffname")}
                  </span>
                  <span className="pim-field__value">
                    {customerDetail.referenceDetail?.referenceName2 || "—"}
                  </span>
                  <span className="pim-field__sub">
                    {customerDetail.referenceDetail?.referenceNumber2}
                  </span>
                </div>
              </div>
            </div>

            <div className="pim-section">
              <div className="pim-section__title">
                {t("AddCustomer.sixCard")}
              </div>
              <div className="pim-proofs">
                {customerDetail.proofs?.map((proof, index) => (
                  <Proof key={index} proof={proof} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}

export default withNamespaces()(withRouter(PersonInfoModal));

const Proof = ({ proof }) => {
  const getFileExtension = (path = "") => path.split(".").pop()?.toLowerCase();
  const isImage = (ext) => ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
  const isPreviewableDoc = (ext) => ["pdf"].includes(ext);

  const fileUrl = `${DOMAIN}${proof.proofImagePath}`;
  const ext = getFileExtension(proof.proofImagePath);

  const handleView = () =>
    window.open(fileUrl, "_blank", "noopener,noreferrer");

  const handleDownload = async () => {
    const response = await fetch(fileUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = proof.proofType || "document";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="pim-proof-row">
      <span className="pim-proof-row__label">{proof.proofType}</span>
      <div className="pim-proof-row__actions">
        {(isImage(ext) || isPreviewableDoc(ext)) && (
          <Tooltip title="View">
            <button
              className="pim-proof-btn pim-proof-btn--view"
              onClick={handleView}
            >
              <Visibility style={{ fontSize: 14, color: "#00D95E" }} /> View
            </button>
          </Tooltip>
        )}
        <Tooltip title="Download">
          <button className="pim-proof-btn" onClick={handleDownload}>
            <Download style={{ fontSize: 14, color: "#3E4664" }} /> Download
          </button>
        </Tooltip>
      </div>
    </div>
  );
};
